export const copyAddress = (copyTextId = "wallet", textAreaId = "textArea") => {
  const copyText = document.getElementById(copyTextId);
  const textArea = document.createElement(textAreaId);
  textArea.value = copyText.textContent;
  document.body.appendChild(textArea);
  textArea.select();
  navigator.clipboard.writeText(textArea.value);
  textArea.remove();
};
